import { ToolDefinition } from '../models/ai-hub.models';

const MOBILE_EMAIL_LINK =
  'mailto:?subject=URLs%20for%20Maximizer%20Mobile%20App%20and%20Mobile%20Access&body=Click%20the%20link%20below%20to%20install%20the%20Maximizer%20native%20app%20for%20your%20device.%0AAndroid%0Ahttps://play.google.com/store/apps/details?id=com.maximizer.crm%0A%0AApple%0Ahttps://itunes.apple.com/us/app/maximizer-crm-for-sales/id1435930775?mt=8%0A%0A%0A';

export const TOOL_DEFINITIONS: readonly ToolDefinition[] = [
  {
    key: 'iqBoost',
    icon: 'wand-magic-sparkles',
    visibilityFlag: 'core-ai-iq-boost-shown',
    imageFile: 'preview-iq-insight-household-card.png',
    sources: {
      fa: ['clientData', 'householdData', 'emails', 'calls', 'notes', 'documents', 'houseView', 'advisorProfile'],
      default: ['clientData', 'addressBookData', 'emails', 'calls', 'notes', 'documents', 'contactView', 'salesProfile'],
    },
    links: [],
    app: { tag: 'maximizer-ai-iqboost', featureFlagId: 'core-ai-iq-boost-menu-shown' },
  },
  {
    key: 'iqBoostWidget',
    icon: 'list',
    visibilityFlag: 'core-ai-iq-boost-widget-shown',
    imageFile: 'preview-iq-inline-summary.png',
    sources: {
      fa: ['clientData', 'householdData', 'emails', 'calls', 'notes', 'documents', 'interactions', 'houseView', 'advisorProfile'],
      default: ['clientData', 'addressBookData', 'emails', 'calls', 'notes', 'documents', 'interactions', 'contactView', 'salesProfile'],
    },
    links: [],
  },
  {
    key: 'meetingPreparation',
    icon: 'calendar-check',
    visibilityFlag: 'core-ai-meeting-preparation-summary-shown',
    orgGateFlag: 'core-ai-anonymizer-enabled',
    imageFile: 'preview-meeting-prep-household-card.png',
    sources: {
      fa: ['clientData', 'householdData', 'emails', 'calls', 'notes', 'documents', 'interactions'],
      default: ['clientData', 'addressBookData', 'emails', 'calls', 'notes', 'documents', 'interactions'],
    },
    links: [],
  },
  {
    key: 'summarization',
    icon: 'file-lines',
    visibilityFlag: 'core-timeline-ai-summarization-shown',
    orgGateFlag: 'core-ai-anonymizer-enabled',
    imageFile: 'preview-timeline-summary-toolbar.png',
    sources: {
      fa: ['clientData', 'householdData', 'emails', 'calls', 'messages', 'notes', 'documents', 'interactions'],
      default: ['clientData', 'addressBookData', 'emails', 'calls', 'messages', 'notes', 'documents', 'interactions'],
    },
    links: [],
  },
  {
    key: 'smartCapture',
    icon: 'mobile-signal-out',
    visibilityFlag: 'mobile-smartcapture-shown',
    hasAnonymizerNote: true,
    sources: { fa: ['clientData', 'householdData', 'emails', 'leadData'], default: ['clientData', 'addressBookData', 'leadData'] },
    links: [
      { labelKey: 'aiHub.tools.links.googlePlay', href: 'https://play.google.com/store/apps/details?id=com.maximizer.crm' },
      { labelKey: 'aiHub.tools.links.appStore', href: 'https://itunes.apple.com/us/app/maximizer-crm-for-sales/id1435930775?mt=8' },
      { labelKey: 'aiHub.tools.links.emailLinkToDevice', href: MOBILE_EMAIL_LINK },
    ],
  },
  {
    key: 'outlook',
    icon: 'envelope',
    visibilityFlag: 'integration-o365-ai-features-enabled',
    hasAnonymizerNote: true,
    sources: { fa: ['clientData', 'householdData', 'leadData', 'emails'], default: ['clientData', 'addressBookData', 'leadData', 'emails'] },
    links: [
      {
        labelKey: 'aiHub.tools.links.appSource',
        href: 'https://marketplace.microsoft.com/en-us/product/WA200005536?tab=Overview',
        icon: 'arrow-up-right-from-square',
      },
    ],
  },
];
